import BaseElement from './BaseElement';
import VideoSeries from '../Components/VideoSeries';
class VideoSeriesPlayer extends BaseElement {
    constructor() {
        super(...arguments);
        this.element = VideoSeries;
    }
}
export default VideoSeriesPlayer;
